import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = [
    'button',
    'menu',
    'icon',
    'iconOpen',
    'iconClosed',
  ]

  declare readonly hasButtonTarget: boolean
  declare readonly buttonTarget: HTMLElement
  declare readonly menuTarget: HTMLElement
  declare readonly hasIconTarget: boolean
  declare readonly iconTarget: HTMLElement
  declare readonly hasIconOpenTarget: boolean
  declare readonly iconOpenTarget: HTMLElement
  declare readonly hasIconClosedTarget: boolean
  declare readonly iconClosedTarget: HTMLElement

  static values = {
    open: Boolean,
  }

  declare openValue: boolean

  connect (): void {
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener('keydown', this.#onMenuButtonKeydown)
      this.buttonTarget.setAttribute('aria-haspopup', 'true')
    }
  }

  disconnect (): void {
    if (this.hasButtonTarget) {
      this.buttonTarget.removeEventListener('keydown', this.#onMenuButtonKeydown)
      this.buttonTarget.removeAttribute('aria-haspopup')
    }
  }

  toggle (): void {
    this.openValue = !this.openValue
  }

  show (): void {
    this.openValue = true
  }

  hide (event: Event): void {
    if (event instanceof KeyboardEvent && event.key === 'Escape') {
      this.openValue = false
      return
    }

    if (this.element.contains(event.target as Node) === false && this.openValue) {
      this.openValue = false
    }
  }

  openValueChanged (): void {
    if (this.openValue) {
      this.#show()
    } else {
      this.#hide()
    }
    this.#updateIcon()
  }

  #show (): void {
    enter(this.menuTarget).then(() => {
      if (this.hasButtonTarget) {
        this.buttonTarget.setAttribute('aria-expanded', 'true')
      }
    })
  }

  #hide (): void {
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'false')
    }

    leave(this.menuTarget)
  }

  #updateIcon (): void {
    if (this.hasIconOpenTarget && this.hasIconClosedTarget) {
      if (this.openValue) {
        this.iconOpenTarget.style.opacity = '1'
        this.iconClosedTarget.style.opacity = '0'
      } else {
        this.iconOpenTarget.style.opacity = '0'
        this.iconClosedTarget.style.opacity = '1'
      }
    }
  }

  #onMenuButtonKeydown = (event: KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault()
        this.toggle()
    }
  }
}
